import { call, put, takeLatest } from '@redux-saga/core/effects';
import { reportMessage } from 'lib/error';
import { svpApiProxyClient } from 'services';

import {
    seriesFetchSuccess,
    seriesFetchError,
    seriesAddSuccess,
    seriesDeleteSuccess,
    seriesUpdateSuccess,
} from './actions';

import { SERIES_FETCH, SERIES_ADD, SERIES_DELETE, SERIES_UPDATE } from './actionTypes';

export function* seriesFetch({ provider, categoryId }) {
    try {
        const series = yield call(svpApiProxyClient.fetchSeries, { provider, categoryId });
        yield put(seriesFetchSuccess(provider, categoryId, series));
    } catch (error) {
        reportMessage({
            message: 'Failed to fetch series',
            error,
        });
        yield put(seriesFetchError(provider, categoryId, error.message));
    }
}

export function* seriesAdd({ provider, categoryId, seasonNumber, seasonTitle, meta }) {
    try {
        const series = yield call(svpApiProxyClient.addSeries, {
            categoryId,
            provider,
            title: seasonTitle,
            seasonNumber,
        });
        yield put(seriesAddSuccess(provider, categoryId, { ...series }, meta));
    } catch (error) {
        reportMessage({
            message: 'Failed to add series',
            error,
        });
    }
}

export function* updateSeries({ provider, categoryId, seasonNumber, seasonTitle, meta }) {
    try {
        const series = yield call(svpApiProxyClient.updateSeries, {
            categoryId,
            provider,
            title: seasonTitle,
            seasonNumber,
        });
        yield put(seriesUpdateSuccess(provider, categoryId, { ...series }, meta));
    } catch (error) {
        reportMessage({
            message: 'Failed to update series',
            error,
        });
    }
}

export function* deleteSeries({ provider, categoryId, seasonNumber, meta }) {
    try {
        yield call(svpApiProxyClient.deleteSeries, { categoryId, provider, seasonNumber });
        yield put(seriesDeleteSuccess(provider, categoryId, seasonNumber, meta));
    } catch (error) {
        if (error.response && error.response.status === 403) {
            const response = yield error.response.json();
            const validationError = new Error(response.errors);
            validationError.status = 400;
        } else {
            reportMessage({
                message: 'Failed to delete series',
                error,
            });
        }
    }
}

export default [
    takeLatest(SERIES_FETCH, seriesFetch),
    takeLatest(SERIES_ADD, seriesAdd),
    takeLatest(SERIES_UPDATE, updateSeries),
    takeLatest(SERIES_DELETE, deleteSeries),
];
